<template>
    <Layout :clientId='clientId' :showid='topicId' :channels='channels' :setTitle='title' :apiOrigin="apiOrigin">
        <div>
            <div class="article">
                <!-- 列表 开始 -->
                <imgList :list="topicList"></imgList>
                <a class="more" @click="more"  :disabled="showMore == '加载中'" v-show="meta.page_count>meta.current_page" href="javascript:;" id="pc-more">{{showMore}}</a>
                <a class="more"  v-show="topicList.length==0||meta.page_count==meta.current_page" href="javascript:;" id="pc-more">没有更多了</a>
            </div>
            <!-- 列表 结束 -->
            <!-- 右侧列表开始 -->
            <div class="aside">
                <!--     <news-img-aside  title="热文"></news-img-aside> -->
                <newsImgAside title="热门新闻" :clientId="clientId" :list="reWenList"></newsImgAside>
            </div>
        </div>
    </Layout>
</template>
<style lang="css">
    @import "~asset/news-pc/css/css.css";
    body {
        margin: 0 0px;
    }
    
    a {
        text-decoration: none;
    }
</style>
<script>
    import Layout from 'component/web/news-layout';
    import newsImgAside from 'component/web/news-aside/img-aside';
    import imgList from 'component/web/news-list/img-list';
    import axios from 'asset/news-pc/js/axios.js';
    import api from 'asset/news-pc/js/api.js';
    export default {
        components: {
            Layout,
            newsImgAside,
            imgList
        },
        data() {
            return {
                page: 2,
                showMore: '加载更多'
            };
        },
        mounted() {

       /*      axios.get(api.news).then(data => {
                this.topicList = data.data.data.items;
                this.pageList = data.data.data.items;
            });
            axios.get(api.rewen).then(data => {
                this.reWenList = data.data.data.items;
            });
            axios.get(api.bianmin).then(data => {
                this.bianMinList = data.data.data.items;
            }); */
        },
        methods: {
            more() {
                this.showMore = '加载中';
                axios.get(`${api.topics}?page=${this.page}`).then(data => {
                    this.topicList = [...this.topicList, ...data.data.data.items];
                
                    this.meta = data.data.data._meta;
                    this.showMore = '加载更多';
                    this.page++;
                });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// app/web/page/news-pc/topic-list.vue